export default {"src":"/_next/static/media/heart.5289dd2f.svg","height":968,"width":968,"blurWidth":0,"blurHeight":0};